// import { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import {
//   Box, Grid, TextField, Button, Typography, Stack,
//   IconButton, Divider, Paper
// } from "@mui/material";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import AddIcon from "@mui/icons-material/Add";
// import DeleteIcon from "@mui/icons-material/Delete";
// import CategoryIcon from "@mui/icons-material/Category";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import MainCard from "components/MainCard";
// import api from "utils/api";

// export default function ProductCategoryForm() {
//   const navigate = useNavigate();
//   const { id } = useParams();
//   const isEdit = Boolean(id);

//   const [form, setForm] = useState({
//     name_en: "",
//     name_ar: "",
//     sequence: "",
//     image: null
//   });
//   const [preview, setPreview] = useState(null);

//   const [times, setTimes] = useState([]);

//   useEffect(() => {
//     if (isEdit) fetchCategory();
//   }, [id]);

//   const fetchCategory = async () => {
//     try {
//       const res = await api.get(`/product/category/${id}`);
//       const data = res.data.data;
//       setForm({
//         name_en:  data.name_en  || "",
//         name_ar:  data.name_ar  || "",
//         sequence: data.sequence || "",
//         image:    null
//       });

//       if (Array.isArray(data.times)) {
//         setTimes(data.times.map(t => ({ from_time: t.from_time || "", to_time: t.to_time || "" })));
//       }
//       if (data.image_url) setPreview(`http://localhost:5000/${data.image_url}`);
//       else if (data.image)    setPreview(`http://localhost:5000/${data.image}`);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm(prev => ({ ...prev, [name]: value }));
//   };

//   const handleFile = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     setForm(prev => ({ ...prev, image: file }));
//     setPreview(URL.createObjectURL(file));
//   };

//   const addTime = () => setTimes(prev => [...prev, { from_time: "", to_time: "" }]);

//   const removeTime = (index) => setTimes(prev => prev.filter((_, i) => i !== index));

//   const updateTime = (index, field, value) => {
//     setTimes(prev => prev.map((t, i) => i === index ? { ...t, [field]: value } : t));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // validate times
//     for (let t of times) {
//       if (!t.from_time || !t.to_time) {
//         alert("Please fill all time slots or remove empty ones");
//         return;
//       }
//     }

//     try {
//       const formData = new FormData();
//       formData.append("name_en",  form.name_en);
//       formData.append("name_ar",  form.name_ar);
//       if (form.sequence !== "") formData.append("sequence", form.sequence);

//       // backend expects times as JSON string
//       if (times.length > 0) {
//         formData.append("times", JSON.stringify(times));
//       }

//       if (form.image) formData.append("image", form.image);

//       if (isEdit) {
//         await api.put(`/product/category/edit/${id}`, formData, {
//           headers: { "Content-Type": "multipart/form-data" }
//         });
//         alert("Category Updated ✅");
//       } else {
//         await api.post("/product/category/add", formData, {
//           headers: { "Content-Type": "multipart/form-data" }
//         });
//         alert("Category Created ✅");
//       }

//       navigate("/product/category/list");
//     } catch (error) {
//       alert(error.response?.data?.message || "Failed ❌");
//     }
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       <Stack direction="row" justifyContent="flex-end" sx={{ mb: 2 }}>
//         <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}>
//           Back
//         </Button>
//       </Stack>

//       <form onSubmit={handleSubmit}>
//         <Grid container spacing={3}>

//           {/* ── Basic Info ── */}
//           <Grid item xs={12}>
//             <MainCard
//               title={
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                   <CategoryIcon color="primary" />
//                   <Typography variant="h6">
//                     {isEdit ? "Edit" : "Create"} Product Category
//                   </Typography>
//                 </Box>
//               }
//             >
//               <Grid container spacing={3}>

//                 <Grid item xs={12} md={4}>
//                   <TextField
//                     fullWidth
//                     label="Name English *"
//                     name="name_en"
//                     value={form.name_en}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={4}>
//                   <TextField
//                     fullWidth
//                     label="Name Arabic"
//                     name="name_ar"
//                     value={form.name_ar}
//                     onChange={handleChange}
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={4}>
//                   <TextField
//                     fullWidth
//                     type="number"
//                     label="Sequence"
//                     name="sequence"
//                     value={form.sequence}
//                     onChange={handleChange}
                 
//                   />
//                 </Grid>

//                 {/* Image Upload */}
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                     Category Image
//                   </Typography>
//                   <Button
//                     variant="outlined"
//                     component="label"
//                     startIcon={<CloudUploadIcon />}
//                     fullWidth
//                     sx={{ mb: 1 }}
//                   >
//                     {form.image ? form.image.name : "Upload Image"}
//                     <input type="file" hidden accept="image/*" onChange={handleFile} />
//                   </Button>
//                   {preview && (
//                     <Box sx={{ mt: 1 }}>
//                       <img
//                         src={preview}
//                         alt="Preview"
//                         style={{ height: 80, borderRadius: 8, objectFit: "cover" }}
//                       />
//                     </Box>
//                   )}
//                   <Typography variant="caption" color="text.secondary">
//                     If no image uploaded, default image will be used
//                   </Typography>
//                 </Grid>

//               </Grid>
//             </MainCard>
//           </Grid>

//           {/* ── Times ── */}
//           <Grid item xs={12}>
//             <MainCard
//               title={
//                 <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                     <AccessTimeIcon color="primary" />
//                     <Typography variant="h6">Availability Times</Typography>
//                   </Box>
//                   <Button
//                     size="small"
//                     variant="contained"
//                     startIcon={<AddIcon />}
//                     onClick={addTime}
//                   >
//                     Add Time Slot
//                   </Button>
//                 </Box>
//               }
//             >
//               {times.length === 0 ? (
//                 <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: "center" }}>
//                   No time slots added. Category will be available all day.
//                 </Typography>
//               ) : (
//                 <Stack spacing={2}>
//                   {times.map((t, index) => (
//                     <Paper key={index} variant="outlined" sx={{ p: 2 }}>
//                       <Grid container spacing={2} alignItems="center">
//                         <Grid item xs={12} md={5}>
//                           <TextField
//                             fullWidth
//                             label="From Time"
//                             type="time"
//                             value={t.from_time}
//                             onChange={e => updateTime(index, "from_time", e.target.value)}
//                             InputLabelProps={{ shrink: true }}
//                             required
//                           />
//                         </Grid>
//                         <Grid item xs={12} md={5}>
//                           <TextField
//                             fullWidth
//                             label="To Time"
//                             type="time"
//                             value={t.to_time}
//                             onChange={e => updateTime(index, "to_time", e.target.value)}
//                             InputLabelProps={{ shrink: true }}
//                             required
//                           />
//                         </Grid>
//                         <Grid item xs={12} md={2}>
//                           <IconButton color="error" onClick={() => removeTime(index)}>
//                             <DeleteIcon />
//                           </IconButton>
//                         </Grid>
//                       </Grid>
//                     </Paper>
//                   ))}
//                 </Stack>
//               )}
//             </MainCard>
//           </Grid>

//           {/* ── Submit ── */}
//           <Grid item xs={12}>
//             <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
//               <Button variant="outlined" onClick={() => navigate(-1)}>
//                 Cancel
//               </Button>
//               <Button type="submit" variant="contained" size="large">
//                 {isEdit ? "Update Category" : "Create Category"}
//               </Button>
//             </Box>
//           </Grid>

//         </Grid>
//       </form>
//     </Box>
//   );
// }

import { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";

import {
  Alert, Box, Grid, TextField, Button, Typography, Stack,
  IconButton, Paper, Chip
} from "@mui/material";
import useFormValidation from "hooks/useFormValidation";
import { validators } from "utils/formValidation";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { ShopOutlined } from "@ant-design/icons";

import MainCard from "components/MainCard";
import api, { resolveAssetUrl } from "utils/api";

export default function ProductCategoryForm() {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  const isEdit = Boolean(id);

  const query    = new URLSearchParams(location.search);
  const store_id = query.get("store_id");

  // ── State ──────────────────────────────────────────────────
  const [storeName,    setStoreName]    = useState("");
  const [loadingStore, setLoadingStore] = useState(false);

  const [form, setForm] = useState({
    name_en:  "",
    name_ar:  "",
    sequence: "",
    image:    null
  });

  const [preview,    setPreview]    = useState(null);
  const [times,      setTimes]      = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const { formError, validate, setServerError, setFieldErrors, clearFieldError, fieldErrorProps } = useFormValidation();

  // ── Init ───────────────────────────────────────────────────
  useEffect(() => {
    const init = async () => {
      if (store_id) await fetchStore();   // ✅ always fetch store name
      if (isEdit)   await fetchCategory();
    };
    init();
  }, [id]);

  // ── Fetch store name ───────────────────────────────────────
  const fetchStore = async () => {
    setLoadingStore(true);
    try {
      const res  = await api.get(`/store/${store_id}`);
      const data = res.data.data;
      setStoreName(data.title_en || data.name || data.name_en || "Unknown Store");
    } catch (err) {
      console.error("[CategoryForm] fetchStore error:", err);
      setStoreName("Unknown Store");
    } finally {
      setLoadingStore(false);
    }
  };

  // ── Fetch category (edit mode only) ───────────────────────
  const fetchCategory = async () => {
    try {
      const res  = await api.get(`/product/category/${id}`);
      const data = res.data.data;

      setForm({
        name_en:  data.name_en  || "",
        name_ar:  data.name_ar  || "",
        sequence: data.sequence || "",
        image:    null
      });

      if (Array.isArray(data.times)) {
        setTimes(
          data.times.map(t => ({
            from_time: t.from_time || "",
            to_time:   t.to_time   || ""
          }))
        );
      }

      if (data.image_url)
        setPreview(resolveAssetUrl(data.image_url));
      else if (data.image)
        setPreview(resolveAssetUrl(data.image));

    } catch (err) {
      console.error("[CategoryForm] fetchCategory error:", err);
    }
  };

  // ── Handlers ───────────────────────────────────────────────
  const handleChange = (e) => {
    const { name } = e.target;
    if (name) clearFieldError(name);
    setForm(prev => ({ ...prev, [name]: e.target.value }));
  };

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setForm(prev => ({ ...prev, image: file }));
    setPreview(URL.createObjectURL(file));
  };

  const addTime = () =>
    setTimes(prev => [...prev, { from_time: "", to_time: "" }]);

  const removeTime = (index) =>
    setTimes(prev => prev.filter((_, i) => i !== index));

  const updateTime = (index, field, value) => {
    setTimes(prev =>
      prev.map((t, i) => i === index ? { ...t, [field]: value } : t)
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate({ name_en: [validators.required("Name (English)")] }, form)) return;

    if (!store_id) {
      setServerError("Store context is missing. Open this form from the store category list.");
      return;
    }

    const timeErrors = {};
    times.forEach((t, index) => {
      if (!t.from_time || !t.to_time) {
        timeErrors[`time_${index}`] = "Fill both from and to times, or remove this slot.";
      }
    });
    if (Object.keys(timeErrors).length) {
      setFieldErrors(timeErrors);
      setServerError("Please complete all time slots or remove empty ones.");
      return;
    }

    setSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("name_en",  form.name_en);
      formData.append("name_ar",  form.name_ar);
      formData.append("store_id", store_id);

      if (form.sequence)
        formData.append("sequence", form.sequence);

      if (times.length > 0)
        formData.append("times", JSON.stringify(times));

      if (form.image)
        formData.append("image", form.image);

      if (isEdit) {
        await api.put(`/product/category/edit/${id}`, formData);
      } else {
        await api.post(`/product/category/add`, formData);
      }

      navigate(`/product/category/list?store_id=${store_id}`);

    } catch (err) {
      console.error("[CategoryForm] submit error:", err);
      setServerError(err.response?.data?.message || "Failed to save category");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 3 }} noValidate>

      {/* ── Header ── */}
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
        <Stack direction="row" alignItems="center" gap={1}>
          <IconButton size="small" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
          <Box>
            <Typography variant="h5">
              {isEdit ? "Edit Category" : "Add Category"}
            </Typography>

            {/*  Store chip — shows on BOTH create & edit */}
            {store_id && (
              <Chip
                icon={<ShopOutlined />}
                label={loadingStore ? "Loading store…" : `Store: ${storeName}`}
                size="small"
                color="primary"
                variant="outlined"
                sx={{ mt: 0.5 }}
              />
            )}
          </Box>
        </Stack>

        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </Stack>

      {formError ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          {formError}
        </Alert>
      ) : null}

      <Grid container spacing={3}>

          {/* ── Category Info ── */}
          <Grid size={{xs:12}}>
            <MainCard title="Category Info">
              <Grid container spacing={3}>

                {/* ✅ Read-only store field */}
                <Grid size={{xs:12}}>
                  <TextField
                    fullWidth
                    label="Store"
                    value={loadingStore ? "Loading…" : storeName}
                    InputProps={{ readOnly: true }}
                    helperText={
                      isEdit
                        ? "Store this category belongs to"
                        : "Category will be created under this store"
                    }
                    sx={{ bgcolor: "grey.50" }}
                  />
                </Grid>

                <Grid size={{xs:4}}>
                  <TextField
                    fullWidth required
                    label="Name EN"
                    name="name_en"
                    value={form.name_en}
                    onChange={handleChange}
                    {...fieldErrorProps("name_en")}
                  />
                </Grid>

                <Grid size={{xs:4}}>
                  <TextField
                    fullWidth
                    label="Name AR"
                    name="name_ar"
                    value={form.name_ar}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid size={{xs:4}}>
                  <TextField
                    fullWidth
                    label="Sequence"
                    type="number"
                    name="sequence"
                    value={form.sequence}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid size={{xs:6}}>
                  <Button component="label" startIcon={<CloudUploadIcon />}>
                    Upload Image
                    <input hidden type="file" onChange={handleFile} />
                  </Button>
                  {preview && (
                    <img
                      src={preview}
                      height={80}
                      style={{ marginLeft: 12, borderRadius: 8 }}
                    />
                  )}
                </Grid>

              </Grid>
            </MainCard>
          </Grid>

          {/* ── Times ── */}
          <Grid size={{xs:12}}>
            <MainCard title="Times">
              <Button onClick={addTime} startIcon={<AddIcon />}>
                Add Time
              </Button>

              {times.map((t, i) => (
                <Paper key={i} sx={{ p: 2, mt: 2 }}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid size={{xs:5}}>
                      <TextField
                        fullWidth
                        type="time"
                        label="From"
                        value={t.from_time}
                        onChange={(e) => updateTime(i, "from_time", e.target.value)}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid size={{xs:5}}>
                      <TextField
                        fullWidth
                        type="time"
                        label="To"
                        value={t.to_time}
                        onChange={(e) => updateTime(i, "to_time", e.target.value)}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid size={{xs:2}}>
                      <IconButton color="error" onClick={() => removeTime(i)}>
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Paper>
              ))}
            </MainCard>
          </Grid>

          {/* ── Submit ── */}
          <Grid size={{xs:12}}>
            <Stack direction="row" spacing={2}>
              <Button
                type="submit"
                variant="contained"
                disabled={submitting || loadingStore}
              >
                {submitting
                  ? "Saving…"
                  : isEdit ? "Update Category" : "Create Category"}
              </Button>
              <Button
                variant="outlined"
                onClick={() => navigate(-1)}
                disabled={submitting}
              >
                Cancel
              </Button>
            </Stack>
          </Grid>

        </Grid>
    </Box>
  );
}